import _enUS from '../en-US/dateTime.json'
import _zhHK from '../zh-HK/dateTime.json'
import _zhCN from '../zh-CN/dateTime.json'

const enUS = { ..._enUS }
const zhHK = { ..._zhHK }
const zhCN = { ..._zhCN }

export default { enUS, zhHK, zhCN }
